import { Suspense, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import KaysvilleHero from './components/KaysvilleHero';
import KaysvilleTrust from './components/KaysvilleTrust';
import KaysvilleServices from './components/KaysvilleServices';
import KaysvilleNeighborhoods from './components/KaysvilleNeighborhoods';
import KaysvilleTestimonial from './components/KaysvilleTestimonial';
import KaysvilleContact from './components/KaysvilleContact';

export default function KaysvillePage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Water Damage Restoration Kaysville Utah | 24/7 Emergency Flood Cleanup Services';
    
    const metaTags = [
      { name: 'description', content: 'Expert water damage restoration in Kaysville, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair near Barnes Park & Cherry Hill. Fast response, certified professionals. Call (385) 340-6632 for immediate assistance.' },
      { name: 'keywords', content: 'water damage restoration Kaysville, flood cleanup Kaysville Utah, emergency water removal Kaysville, mold remediation Kaysville, fire damage repair Kaysville' },
      { name: 'geo.position', content: '41.0352;-111.9385' },
      { name: 'geo.region', content: 'US-UT' },
      { name: 'geo.placename', content: 'Kaysville, Utah' },
      { property: 'og:title', content: 'Water Damage Restoration Kaysville Utah | Davis County Disaster Cleanup' },
      { property: 'og:description', content: '24/7 emergency water damage restoration in Kaysville. Expert flood cleanup, mold removal, and disaster recovery services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://daviscountydisastercleanup.com/kaysville' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Water Damage Restoration Kaysville Utah | Davis County Disaster Cleanup' },
      { name: 'twitter:description', content: '24/7 emergency water damage restoration in Kaysville. Expert flood cleanup and disaster recovery.' }
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value as string);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content as string);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/kaysville');

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide 24/7 emergency water damage restoration in Kaysville?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Davis County Disaster Cleanup provides 24/7 emergency water damage restoration services throughout Kaysville, Utah. We respond immediately to water emergencies near Barnes Park, Cherry Hill, Mutton Hollow, and all Kaysville neighborhoods."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can you respond to water damage in Kaysville?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We typically arrive within 60 minutes for emergency water damage calls in Kaysville. Our local team knows the area well, from downtown Kaysville to Kaysville Heights, ensuring rapid response times."
          }
        },
        {
          "@type": "Question",
          "name": "What areas of Kaysville do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve all of Kaysville including Barnes Park area, Mutton Hollow, Cherry Hill, Downtown Kaysville, West Kaysville, and Kaysville Heights. No location in Kaysville is too far for our emergency response team."
          }
        }
      ]
    };

    let script = document.querySelector('script[data-schema="kaysville-faq"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-schema', 'kaysville-faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="kaysville-faq"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <KaysvilleHero />
        <KaysvilleTrust />
        <KaysvilleServices />
        <KaysvilleNeighborhoods />
        <KaysvilleTestimonial />
        <KaysvilleContact />
        <Footer />
      </div>
    </Suspense>
  );
}
